import FieldModel from './FieldModel';
import { TextInput } from '../inputs';
import { verifyInput } from '../../../../juristec-ui/utils/validators/inputTextValidators';
import { trimString } from '../../../../juristec-ui/utils/functions/formatString';

class TextField extends FieldModel {
  getDefaultState = () => ({
    value: this.default ?? '',
    error: Boolean(this.required),
    errorMsg: this.required ? 'Este campo não pode estar vazio' : '',
  });

  handleInput = (e, handle) => {
    const val = e.target.value;
    const msg = verifyInput(val, this.required, 5);
    handle({
      [this.kWord]: {
        value: val,
        error: msg.length !== 0,
        errorMsg: msg,
      },
    });
  }

  handleBlurTrim = (e, handle) => {
    const val = e.target.value;
    const msg = verifyInput(val, this.required, 5);
    handle({
      [this.kWord]: {
        value: trimString(val).trim(),
        error: msg.length !== 0,
        errorMsg: msg,
      },
    });
  }

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (e) => this.handleInput(e, handle);
    const prepBlur = (e) => this.handleBlurTrim(e, handle);
    return (
      <TextInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
        blur={prepBlur}
      />
    );
  }
}

export default TextField;
